import { useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import {
  configurationStepsState,
  indexColumnMatchesState,
  selectedEntityState,
} from '../../state/ConfigurationState';
import { useResetConfigState } from './useResetConfigState';

export function useConfigurationSteps() {
  const resetConfigState = useResetConfigState();
  const activeStep = useAtomValue(configurationStepsState);
  const setIndexColumnMatches = useSetAtom(indexColumnMatchesState);
  const setSelectedEntity = useSetAtom(selectedEntityState);
  const setActiveStep = useSetAtom(configurationStepsState);

  const isActionable = useCallback(
    (stepIndex: number) => {
      return stepIndex < activeStep;
    },
    [activeStep]
  );

  const handleStepClick = useCallback(
    async (stepIndex: number) => {
      switch (stepIndex) {
        case 0: {
          resetConfigState();
          return;
        }
        case 1: {
          setIndexColumnMatches(new Map());
          setSelectedEntity(null);
          setActiveStep(stepIndex);
          return;
        }

        default:
          return;
      }
    },
    [resetConfigState, setActiveStep, setIndexColumnMatches, setSelectedEntity]
  );

  return { handleStepClick, isActionable };
}
